/* Fake sale-campaign countdown — shared by the header banner
 * (sale-countdown-banner.liquid) and the PDP "Sale Ends" price timer
 * (wall-art-price-atc.liquid + wall-art-sale-pricing.js).
 *
 * Behaviour (per spec — this is an URGENCY device, not a real campaign clock):
 *   - Starts at DURATION (1h 43m 24s) the FIRST time a visitor hits any page in
 *     the session, then counts down second-by-second.
 *   - Survives reloads + same-tab navigation: the deadline is persisted in
 *     sessionStorage, so a refresh continues the SAME countdown — it never
 *     resets within a session.
 *   - A brand-new session (new tab / browser) starts a fresh countdown.
 *   - Clamps at 00:00:00 (never goes negative; not reset mid-session).
 *
 * Renders every `[data-sale-countdown]` element once per second:
 *   - format="dhms" (banner): fills child [data-cd-days] / [data-cd-hours] /
 *     [data-cd-mins] / [data-cd-secs] with zero-padded 2-digit values.
 *   - format="clock" (PDP timer): fills [data-cd-clock] with HH:MM:SS.
 * Re-scans the DOM each tick, so elements revealed/injected after load (e.g. the
 * PDP "Sale Ends" span, un-hidden by wall-art-sale-pricing.js) update too.
 */
(function () {
  if (window.__yukiSaleCountdownInit) return;
  window.__yukiSaleCountdownInit = true;

  // Fake starting duration: 1h 43m 24s. Single source of truth (the header
  // banner + the PDP timer both read the shared deadline below). Change here
  // to retune the urgency window.
  var DURATION_MS = ((1 * 60 + 43) * 60 + 24) * 1000;
  var STORAGE_KEY = 'yuki:sale-countdown:deadline';

  // Resolve the deadline ONCE per page load. sessionStorage is shared across
  // same-tab reloads + navigations, so the countdown is continuous within a
  // session; a fresh session has no key → a new deadline is minted.
  function resolveDeadline() {
    var raw = null;
    try { raw = sessionStorage.getItem(STORAGE_KEY); } catch (e) { raw = null; }
    var ts = raw ? parseInt(raw, 10) : NaN;
    if (!isFinite(ts) || ts <= 0) {
      ts = Date.now() + DURATION_MS;
      try { sessionStorage.setItem(STORAGE_KEY, String(ts)); } catch (e) { /* private mode — runs in-memory for this load */ }
    }
    return ts;
  }
  var deadline = resolveDeadline();

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function remaining() {
    var secs = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
    return {
      days: Math.floor(secs / 86400),
      hours: Math.floor((secs % 86400) / 3600),
      minutes: Math.floor((secs % 3600) / 60),
      seconds: secs % 60,
      total: secs,
    };
  }

  function setText(root, sel, text) {
    var el = root.querySelector(sel);
    if (el && el.textContent !== text) el.textContent = text;
  }

  function render() {
    var r = remaining();
    var clock = pad(r.hours) + ':' + pad(r.minutes) + ':' + pad(r.seconds);
    var nodes = document.querySelectorAll('[data-sale-countdown]');
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if ((node.getAttribute('data-sale-countdown-format') || 'dhms') === 'clock') {
        setText(node, '[data-cd-clock]', clock);
      } else {
        setText(node, '[data-cd-days]', pad(r.days));
        setText(node, '[data-cd-hours]', pad(r.hours));
        setText(node, '[data-cd-mins]', pad(r.minutes));
        setText(node, '[data-cd-secs]', pad(r.seconds));
      }
    }
  }

  function start() {
    render();
    setInterval(render, 1000);
  }

  // Exposed so wall-art-sale-pricing.js can force an immediate fill the moment
  // it reveals the PDP "Sale Ends" span (avoids a 1s placeholder flash).
  window.YukiSaleCountdown = { refresh: render, remaining: remaining };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
